import { useState } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";

const Dropdown = ({ menuItem, stickyMenu, uppercase, lineBottom, py }: any) => {
  const [dropdownToggler, setDropdownToggler] = useState(false);
  const pathUrl = usePathname();

  return (
    <li
      onClick={() => setDropdownToggler(!dropdownToggler)}
      className={`group relative before:w-0 before:h-[3px] before:bg-purple before:absolute before:left-0 before:rounded-b-[3px] before:ease-out before:duration-200 hover:before:w-full ${
        pathUrl.includes(menuItem.name || menuItem.title) && "before:!w-full"
      }
      ${lineBottom ? "before:bottom-0" : "before:top-0"}
      `}
    >
      <a
        href="#"
        title={menuItem.title ?? menuItem.name}
        className={`hover:text-purple text-custom-sm text-dark flex items-center gap-1.5
          ${stickyMenu ? "xl:py-2" : py ?? "xl:py-4"}
          ${uppercase ? "uppercase" : "capitalize"}
          ${pathUrl.includes(menuItem.name || menuItem.title) && "!text-purple"}
          `}
      >
        {menuItem.name}
        <svg
          className="fill-current cursor-pointer"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.95363 5.67461C3.13334 5.46495 3.44899 5.44067 3.65866 5.62038L7.99993 9.34147L12.3412 5.62038C12.5509 5.44067 12.8665 5.46495 13.0462 5.67461C13.2259 5.88428 13.2017 6.19993 12.992 6.37964L8.32532 10.3796C8.13808 10.5401 7.86178 10.5401 7.67453 10.3796L3.00787 6.37964C2.7982 6.19993 2.77392 5.88428 2.95363 5.67461Z"
            fill=""
          />
        </svg>
      </a>

      {/* <!-- Dropdown Start --> */}
      <ul
        className={`dropdown absolute bg-white z-20 ${dropdownToggler && "flex"} ${
          stickyMenu
            ? "xl:group-hover:translate-y-0"
            : "xl:group-hover:translate-y-0"
        }`}
      >
        {menuItem.submenu.map((item, i) => (
          <li key={i}>
            <Link
              href={item.path}
              title={item.title ?? item.name}
              className={`flex text-custom-sm hover:text-purple hover:bg-gray-1 py-[7px] px-4.5 ${
                pathUrl === item.path && "text-purple bg-gray-1"
              } `}
            >
              {item.name ?? item.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default Dropdown;
